document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".testimonials").forEach((section) => {

    const track = section.querySelector(".testimonials__track");
    const cards = [...track.querySelectorAll(".testimonial-card")];

    const prev = section.querySelector(".testimonials__arrow--prev");
    const next = section.querySelector(".testimonials__arrow--next");
    const dotsContainer = section.querySelector(".testimonials__dots");

    if (!track || cards.length === 0) return;

    let current = 0;

    cards.forEach((_, index) => {

      const dot = document.createElement("button");
      dot.className = "testimonials__dot";

      if (index === 0)
        dot.classList.add("active");

      dot.addEventListener("click", () => {
        goTo(index);
      });

      dotsContainer.appendChild(dot);

    });

    const dots = [...dotsContainer.querySelectorAll(".testimonials__dot")];

    function updateDots() {

      dots.forEach((dot, i) => {
        dot.classList.toggle("active", i === current);
      });

    }

    function updateHeight() {

      const activeCard = cards[current];

      if (!activeCard) return;

      track.style.height = activeCard.offsetHeight + "px";

    }

    function goTo(index) {

      current = index;

      track.scrollTo({
        left: cards[index].offsetLeft,
        behavior: "smooth"
      });

      updateDots();
      updateHeight();

    }

    prev?.addEventListener("click", () => {
      goTo((current - 1 + cards.length) % cards.length);
    });

    next?.addEventListener("click", () => {
      goTo((current + 1) % cards.length);
    });

    track.addEventListener("scroll", () => {

      const index = Math.round(track.scrollLeft / track.clientWidth);

      if (index !== current) {

        current = index;

        updateDots();
        updateHeight();

      }

    });

    window.addEventListener("resize", updateHeight);

    updateDots();
    updateHeight();

  });

});